import { useMutation, UseMutationResult } from '@tanstack/react-query'
import {
  CompanyBulkCreateSchema,
  createBulkCompanyCompaniesPost,
  CreateCompanyCompaniesPostResponse,
  HTTPValidationError,
} from '@common/config/api/client'
import { AxiosError } from 'axios'

/**
 * Hook for bulk creating companies
 * @returns UseMutationResult for creating multiple companies
 */
export const useCreateBulkCompanies = (): UseMutationResult<
  CreateCompanyCompaniesPostResponse,
  AxiosError<HTTPValidationError>,
  { companyData: CompanyBulkCreateSchema }
> => {
  return useMutation<
    CreateCompanyCompaniesPostResponse,
    AxiosError<HTTPValidationError>,
    { companyData: CompanyBulkCreateSchema }
  >({
    mutationFn: async ({ companyData }) => {
      const response = await createBulkCompanyCompaniesPost({
        body: companyData,
        throwOnError: true,
      })
      return response.data
    },
  })
}
